import { useState } from "react"

import { UITypes } from "types"

import { TableSelectContent } from "./TableSelectContent"

interface SimpleTableSelectProps {
  headerCell: UITypes.TableHeaderCell
  isColorSelect?: boolean
}

export const SimpleTableSelect = ({ headerCell, isColorSelect = false }: SimpleTableSelectProps) => {
  const { name, title, options, onSelect } = headerCell
  const [selectValue, setSelectValue] = useState<UITypes.Option | null>(null)

  const handleChange = (option: UITypes.Option | null) => {
    setSelectValue(option)
    onSelect?.(option)
  }

  return (
    <TableSelectContent
      name={name}
      options={options}
      placeholder={title}
      value={selectValue}
      isColorSelect={isColorSelect}
      onChange={handleChange}
    />
  )
}
